export default "__VITE_ASSET__DHG3a8yU__"